import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    'usaCode': Number,
   }
  static targets = [
    'country',
    'state',
    'province',
    'district',
    'setoCheck',
    'seto'
  ]

  initialize () {
    this.toggleStateProvinceDistrict()
    this.toggleSetoFields()
  }

  countryChanged() {
    this.toggleStateProvinceDistrict()
    this.clearStateProvinceDistrict()
  }

  showProvinceDistrict() {
    this.stateTarget.classList.toggle('hidden', true)
    this.provinceTarget.classList.toggle('hidden', false)
    this.districtTarget.classList.toggle('hidden', false)
  }
  
  showState() {
    this.stateTarget.classList.toggle('hidden', false)
    this.provinceTarget.classList.toggle('hidden', true)
    this.districtTarget.classList.toggle('hidden', true)
  }

  toggleStateProvinceDistrict() {
    if(this.countryTarget.value == this.usaCodeValue){
      this.showState()
    }else{
      this.showProvinceDistrict()
    }
  }

  clearStateProvinceDistrict() {
    this.stateTarget.querySelector('select').value = ""
    this.provinceTarget.querySelector('input').value = ""
    this.districtTarget.querySelector('input').value = ""
  }

  toggleSetoFields() {
    if(this.setoCheckTarget.checked) {
      this.showSeto()
    } else {
      this.hideSeto()
    }
  }

  showSeto() {
    this.setoTarget.classList.toggle('hidden', false)
  }

  hideSeto() {
    this.setoTarget.classList.toggle('hidden', true)
    this.clearSetoFields()
  }

  clearSetoFields() {
    this.setoTarget.querySelectorAll('input').forEach((field) => field.value = "")
  }
}
